<template>
  <el-container v-if="loaded">
    <el-main>
      <!-- <p>{{displayScope}}</p> -->
      <el-row>
        <transition name="el-zoom-in-bottom">
          <el-menu
            v-if="displayScope"
            :default-active="showTransactions?'drafts':'businessDetails'"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#009688"
            text-color="#fff"
            active-text-color="#ffd04b"
            @select="handleSelectSubView"
          >
            <el-menu-item index="all" title="δες τα ολα">
              <i class="material-icons">close</i>
              {{$route.params.view=='contact'?'':displayScope}}
            </el-menu-item>
            <el-menu-item index="drafts">
              <i class="material-icons">list</i>
              <span v-if="!isWindowSize('sm')">Συνδιαλλαγές</span>
            </el-menu-item>
            <el-menu-item index="businessDetails" v-if="$route.params.view=='contact'">
              <i class="material-icons">contacts</i>
              {{displayScope}}
            </el-menu-item>
          </el-menu>
        </transition>
        <el-row
          v-if="showTransactions"
          label="Συναλλαγές"
          name="transactions"
          @tab-remove="$router.push({name: $route.name,params:{id:'all'}});"
        >
          <!-- <el-header :height="'80px'" :class="$route.params.direction+'-header'"> -->
          <transition name="el-zoom-in-bottom">
            <el-row v-if="sums.ever">
              <el-dropdown
                v-if="isWindowSize('sm')"
                style="float:right; width: 100%;"
                :type="(sums.ever.calcbalanse<-1)?'warning':'success'"
                size="medium"
                class="sum_dropdown_btn"
                split-button
              >
                <span style="font-size:14px">
                  <i class="material-icons" style="font-size:11px">vertical_align_center</i>
                  {{$theMoney(sums.ever.calcbalanse)}}&euro;
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <i aria-hidden="true" class="icon material-icons">shopping_cart</i>
                    {{$theMoney(sums.ever.depts)}}&euro;
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <i aria-hidden="true" class="icon material-icons">euro_symbol</i>
                    {{$theMoney(sums.ever.payments)}}&euro;
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else>
                <el-col :md="8" style="padding:3px">
                  <s-action-pannel
                    width="100%"
                    style="padding:2px"
                    :clickable="true"
                    @click="downloadExcel()"
                  >
                    <el-button slot="actions" type="success" class="supermini">
                      <i class="material-icons">file_download</i>
                    </el-button>

                    <i class="material-icons">vertical_align_center</i>
                    <span>{{$theMoney(sums.ever.calcbalanse)}}&euro;</span>
                  </s-action-pannel>
                </el-col>
                <el-col :md="8" style="padding:3px">
                  <s-action-pannel width="100%" style="padding:5px" :clickable="false">
                    <i aria-hidden="true" class="icon material-icons">shopping_cart</i>
                    {{$theMoney(sums.ever.depts)}}&euro;
                  </s-action-pannel>
                </el-col>
                <el-col :md="8" style="padding:3px">
                  <s-action-pannel width="100%" style="padding:5px" :clickable="false">
                    <i aria-hidden="true" class="icon material-icons">euro_symbol</i>
                    {{$theMoney(sums.ever.payments)}}&euro;
                  </s-action-pannel>
                </el-col>
              </div>
            </el-row>
          </transition>
          <!-- </el-col> -->
          <!-- </el-row> -->
          <transition name="el-zoom-in-bottom">
            <el-row v-if="sums.selected.count">
              <el-col :md="4" style="padding:3px">
                <s-action-pannel width="100%" style="padding:5px" :clickable="false">
                  <!-- <i aria-hidden="true" class="icon material-icons">shopping_cart</i> -->
                  επιλεγμενα:{{sums.selected.count}}
                </s-action-pannel>
              </el-col>
              <el-col :md="10" style="padding:3px">
                <s-action-pannel width="100%" style="padding:5px" :clickable="false">
                  <i aria-hidden="true" class="icon material-icons">shopping_cart</i>
                  {{$theMoney(sums.selected.depts)}}&euro;
                </s-action-pannel>
              </el-col>
              <el-col :md="10" style="padding:3px">
                <s-action-pannel width="100%" style="padding:5px" :clickable="false">
                  <i aria-hidden="true" class="icon material-icons">euro_symbol</i>
                  {{$theMoney(sums.selected.payed)}}&euro;
                </s-action-pannel>
              </el-col>
            </el-row>
          </transition>
          <el-row :gutter="5">
            <el-col :md="11" :sm="22" :xs="22">
              <transition name="el-zoom-in-bottom">
                <el-row :gutter="5" style="display:flex;" v-if="sums.period">
                  <el-col :md="2" :sm="4" :xs="4">
                    <r-tools
                      @done="++clock;"
                      v-model="workingBusiness"
                      :selectedDrafts="selectedDrafts"
                      :buisnessTools="workingBusiness&&!!workingBusiness.businessId"
                    ></r-tools>
                  </el-col>
                  <el-col :md="11" :sm="22" :xs="22">
                    <s-action-pannel
                      @click="Transdraft={};$router.push({name: 'transaction',params: { transid: 'newpayment' }  });"
                    >
                      <el-button slot="actions" type="success">
                        <i aria-hidden="true" class="icon material-icons">euro_symbol</i>
                      </el-button>

                      <span
                        v-if="sums&&sums.period&&sums.period.payments"
                      >{{$theMoney(sums.period.payments)}}&euro;</span>
                    </s-action-pannel>
                  </el-col>
                  <el-col :md="11" :sm="22" :xs="22">
                    <s-action-pannel
                      @click="Transdraft={};$router.push({name: 'transaction',params: { transid: 'newdept' }  });"
                    >
                      <el-button type="warning" slot="actions">
                        <!-- <i class="fas fa-plus-square"></i> -->
                        <i aria-hidden="true" class="icon material-icons">shopping_cart</i>
                      </el-button>
                      <span v-if="sums.period">{{$theMoney(sums.period.depts)}}&euro;</span>
                    </s-action-pannel>
                  </el-col>
                </el-row>
              </transition>
            </el-col>
            <el-col :md="12" :sm="24" :xs="24">
              <r-searcher v-model="qTransactions"></r-searcher>
            </el-col>
            <!-- </el-row>
            </s-responsive-panel>-->
          </el-row>
          <el-row>
            <el-menu
              :default-active="transactionsState"
              class="el-menu-demo"
              mode="horizontal"
              @select="handleTransactionsState"
              background-color="#009688"
              text-color="#fff"
              active-text-color="#ffd04b"
            >
              <el-menu-item index="toggleSelect" vxif="workingBusiness&&workingBusiness.businessId">
                <i class="material-icons" style="color: inherit;">check_box</i>
              </el-menu-item>
              <el-menu-item index="all">
                <i class="material-icons" style="color: inherit;">vertical_align_center</i>
                <span v-if="!isWindowSize('sm')">Ολα</span>
              </el-menu-item>

              <el-menu-item index="depts">
                <i class="material-icons" style="color: inherit;">shopping_cart</i>
                <span v-if="!isWindowSize('sm')">Χρεωσεις</span>
              </el-menu-item>
              <el-menu-item index="payments">
                <i class="material-icons" style="color: inherit;">euro_symbol</i>
                <span v-if="!isWindowSize('sm')">Πληρωμες</span>
              </el-menu-item>
              <el-menu-item index="notes">
                <i class="material-icons" style="color: inherit;">comment</i>
                <span v-if="!isWindowSize('sm')">Σημειώσεις</span>
              </el-menu-item>
            </el-menu>
          </el-row>
          <!-- </el-header> -->
          <!-- <p>{{transactionsState}}</p> -->
          <s-table
            v-if="loaded"
            :selectMode="selectDrafts"
            :topOffset="displayScope?30:5"
            row-key-field="id"
            heightWish="tobottom"
            simpleLazyLoader
            @cell-clicked="selectTrans"
            :key="clock"
            :colDefinitions="colDefinitions"
            modx-processor="transdrafts/vuegetlist"
            :r-query="qTransactions"
            :row-class-factory="rowStyler"
            v-model="listedTransactions"
            ref="listedTransactions"
            wake-up-route="transactions"
            @select="setSelectedDrafts"
            :selectable="transIsSelectable"
          ></s-table>
        </el-row>
        <!--  v-if="displayScope&&businessDetailsView" -->
        <business-panel
          v-else
          :key="workingBusiness.businessId"
          :contact-data="workingBusiness"
          @detailsChanged="updateBusinessDetails"
          @businessChange="reloadBusiness"
          @delete="delBusiness"
        ></business-panel>

        <el-drawer
          ref="draftDrawer"
          class="dark"
          append-to-body
          round
          :wrapperClosable="false"
          @close="$router.replace({ name: 'transview', params: { transid: null } })"
          position="right"
          direction="rtl"
          :size="isWindowSize('sm')?'95%':'50%'"
          :visible.sync="showDialog"
          get-container="#app"
        >
          <!-- <h4 slot="title">{{Transdraft?Transdraft['name-afm']:'new'}}</h4> -->
          <r-trans-draft
            :transactionData="Transdraft"
            ckey="(Transdraft)?Transdraft.id:''"
            @delete="clearDraft"
            @link="gotoInvoice"
            @save="handleDraftClose(true)"
            @new="addNewTrans"
          ></r-trans-draft>
        </el-drawer>
        <drafts-table @refresh="refreshDrafts"></drafts-table>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import format from "date-fns/format";
import * as api from "~/api/resource";
import { async } from "q";

export default {
  data() {
    return {
      selectedDrafts: null,
      selectDrafts: false,
      ctx: "in",
      businessDetailsView: false,
      showDialog: false,
      listedTransactions: [],
      Transdraft: null,
      qTransactions: {
        active: true,
        transctx: "in",
        isbusiness: 1,
        mode: "full",
        businessId: null,
        view: "extented",
        focus: null,
        exacttag: null,
        // rangeApplyOnTime: true,
        // rangeApplyOnAlert: false
      },
      sums: {
        ever: null,
        period: null,
        past: null,
        selected: { depts: 0, payed: 0, count: 0 },
      },
      transactionsState: "all",
      activeTab: "transactions",
      workingBusiness: {},
      pendingLink: null,
      drawerIsOpen: true,
      searchBusiness: null,
      searchTransactions: null,
      invoiceState: "all",
      dateRange: [],
      listedInvoices: [],
      selectedInvoice: {},
      clock: 0,
      canEdit: true,
      aggregators: { cost: 0, costincl: 0 },
      contentFrame: "width:calc(100vw - 700px);",
      drawerWidth: 500,
      loaded: false,
      userProfile: UserProfile,
      printerLang: "gr",
      dateFormat: "DD/MM/YY",
    };
  },

  methods: {
    transIsSelectable(row) {
      return true;
      // _log_("CAN select  ", row);
      // if (row.deptamound && !row.refnum) return true;

      // return false;
    },
    setSelectedDrafts(drafts) {
      const vm = this;
      vm.selectedDrafts = [];
      this.sums.selected.count = 0;
      this.sums.selected.payed = 0;
      this.sums.selected.depts = 0;
      // this.selectedDrafts=  drafts;
      drafts.forEach((row) => {
        if (
          row.deptamound &&
          !row.refnum &&
          vm.workingBusiness &&
          vm.workingBusiness.businessId
        )
          vm.selectedDrafts.push(row);
        vm.sums.selected.depts += row.deptamound;
        vm.sums.selected.payed += row.payedamound;
        ++vm.sums.selected.count;
      });
    },
    handleSelectSubView(e) {
      this.businessDetailsView = e == "businessDetails";
      if (e == "all")
        this.routeGo({ name: this.$route.name, params: { id: "all" } });
      //@tab-remove="$router.push({name: $route.name,params:{id:'all'}});"
    },
    delBusiness(e) {
      _log_("ROUTE 1  ", e);
      this.routeGo({
        name: "transview",
        params: { view: "contact", id: "all", direction: this.ctx },
      });
      this.$emit("removeContact", e);
    },
    reloadBusiness(e) {
      // _log_("ROUTE 1  ", e);
      if (e.businessId) {
        this.$router.replace({
          // name: "contact",
          params: { id: e.businessId },
        });
        this.qTransactions.businessId = e.businessId;
      }
    },
    updateBusinessDetails(e) {
      _log_("hell,", e);
    },
    addNewTrans(e) {
      ++this.clock;
      // this.$refs.listedTransactions.updateRow({ id: e.id }, e, true); //appendTrackedData([e]);
      this.$refs.draftDrawer.closeDrawer();
      this.$emit("updateBusiness", this.workingBusiness);
      // this.refreshSums();
    },

    async handleDraftClose(refresh) {
      _log_("PENDING link...", this.workingBusiness);
      this.$emit("updateBusiness", this.workingBusiness);
      if (this.Transdraft && this.Transdraft.id) {
        if (this.pendingLink) {
          //pipeActions(['Transdraft=>transdrafts/update','id=>transdrafts/issueinvoice','->jumpToInvoice']);
          if (this.pendingLink.params.id == "new") {
            var d = await api.updateProcessor(
              "transdrafts/update",
              this.Transdraft
            );

            d = await api.fetchProcessor(
              "transdrafts/issueinvoice",
              this.Transdraft
            );

            if (d.data && d.data.results)
              this.pendingLink.params.id = d.data.results.timologioId;
          }
          if (
            this.pendingLink.params.id &&
            this.pendingLink.params.id != "new"
          ) {
            // _log_("ROUTE 2  ");
            //  this.$router.replace( {params: { id: 'new'} });
            this.routeGo(this.pendingLink);
          }
          this.pendingLink = null;
        }
      }

      // this.$router.replace({ name: "transview", params: { transid: null } });
      if (refresh) ++this.clock;
      this.refreshSums();
      // _log_("hell,this.clock,", this.clock);
      this.$refs.draftDrawer.closeDrawer();
      this.$emit("refresh");
      // this.routeGo({
      //   name: "contact",
      //   params: {
      //     id: this.workingBusiness.businessId
      //       ? this.workingBusiness.businessId
      //       : "all"
      //   }
      // });

      // this.Transdraft = {};
    },
    refreshDrafts() {
      ++this.clock;
      this.$emit("updateBusiness", this.workingBusiness);
      this.routeGo({ name: "transview", params: { transid: null } });

      this.refreshSums();

      this.$emit("refresh");
    },
    gotoInvoice(e) {
      this.pendingLink = e;
      this.$refs.draftDrawer.closeDrawer();
    },
    async refreshSums() {
      _log_("GO!SUMS!!???", this.qTransactions);
      if (!this.hasChange("qTransactions", this.qTransactions)) return;
      _log_("hell,!SUMS!!!!!", this.qTransactions);
      const sumsPeriod = await api.fetchProcessor("transdrafts/vuegetlist", {
        ...this.qTransactions,

        view: "sums",
      });
      _log_("hell,DONE SUMS..", sumsPeriod);
      this.$set(this.sums, "period", sumsPeriod.data.object);
      this.sums.period = sumsPeriod.data.object;
      const sumsEver = await api.fetchProcessor("transdrafts/vuegetlist", {
        ...this.qTransactions,
        // isbusiness: this.ctx == "in" ? 1 : 0,
        // isprovider: this.ctx == "in" ? 0 : 1,
        // searchdaterange: this.qTransactions.searchdaterange,
        // businessId: this.qTransactions.businessId,
        // transctx: this.qTransactions.transctx,
        view: "sums",
        mode: "ever",
      });
      this.$set(this.sums, "ever", sumsEver.data.object);
      //    this.sums.ever = sumsEver.data.object;
      _log_("ela re.SUMS..", this.sums);
      // var { data } = await api.fetchProcessor("transdrafts/vuegetlist", {
      //   ...this.qTransactions,
      //   limit: 1
      // });
      // this.getTheSums(data);
    },
    clearDraft(e) {
      this.$refs.listedTransactions.removeRow({ id: e.id });
      this.refreshSums();
      // var dr = this.findInArray(this.listedTransactions, {
      //   id: e.id
      // });
      //   var tr = this.findInArray(this.listedTransactions, { id: e.id });

      // if (tr) {
      //   for (const key in tr) {
      //     if (tr.hasOwnProperty(key)&&key!='idx'&&key!='id') {
      //       delete tr[key];
      //         _log_("oooooo...", key);
      //     }
      //   }
      // }
      this.$refs.draftDrawer.closeDrawer();
      this.$emit("updateBusiness", this.workingBusiness);

      ++this.clock;
    },
    getTheSums(data) {
      _log_("sums...", data);
      // if (data.sums) this.sums = data.sums;
    },
    downloadExcel() {
      api.ajax_download("transdrafts/vuegetlist", {
        ...this.qTransactions,
        download: 1,
      });
    },
    rowStyler(r) {
      // r;
      if (r.row.cost == 0) return "row-note";
      return (
        "row-" +
        r.row.type +
        " " +
        (Math.abs(r.row.deptamound - r.row.balanse) <= 0.01
          ? "row-payed"
          : "") +
        " " +
        (r.row.exectime < 100 ? "row-freezed" : "")
      );
    },
    handleTransactionsState(e) {
      if (e == "toggleSelect") {
        this.selectDrafts = !this.selectDrafts;
        this.selectedDrafts = [];
        this.sums.selected.count = 0;
        this.sums.selected.payed = 0;
        this.sums.selected.depts = 0;
        // if (!this.selectDrafts) this.selectedDrafts = null;
        return;
      }
      this.qTransactions.focus = e == "all" ? null : e;
      this.transactionsState = e;
    },
    // resolveRoute() {
    //   const sanitise = [
    //     "intagsintrans",
    //     "incontactintrans",
    //     "outtagsouttrans",
    //     "outcontactouttrans"
    //   ];
    //   return sanitise.indexOf(this.$route.name) < 0
    //     ? this.$route.name + this.ctx + "trans"
    //     : this.$route.name;
    // },
    selectTrans(e) {
      _log_("ROUTE 1  ", e);
      _log_("ROUTE 3 oooooo...", e);
      if (e.column.property == "balanse" && e.row.deptamound)
        this.$router.replace({
          query: { selectedTrans: e.row.id },
        });
      else
        this.$router.replace({
          name: "transaction",
          params: { transid: e.row.id },
        });

      // this.Transdraft = e.row;
      // this.showDialog = true;
    },
    newTransaction(businessId, transtype) {
      var vuem = this;
      // chainedAjax(
      //   "transdrafts/get",
      //   {
      //     type: transtype,
      //     businessId: businessId
      //   },
      //   function(data) {
      //     if (!data.object) {
      //       alert(
      //         "Παρουσιαστικε καποι τεχνικο πρόβλημα, για προσπαθησε ακομα μια"
      //       );
      //       return false;
      //     }
      //     //data.results.availability
      //     vuem.transactions.unshift(data.object);
      //     vuem.Transdraft = vuem.transactions[0];
      //     vuem.transDialog = true;
      //     // THEDC.updateObject('availability', data.results);

      //     // businesss.forEach(cst => {
      //     //     THEDC.appendInArray('availability', cst);
      //     // });
      //   }
      // );
    },
    pipeActions() {
      _log_("oooooo");
    },
  },
  async mounted() {
    this.loaded = false;
    _log_("theRRRR///", this.$route);
    // this.ctx = this.$route.params.direction;
    // this.qTransactions.isbusiness = this.ctx == "in" ? 1 : 0;
    this.qTransactions.transctx = this.ctx;
    if (
      this.$route.params.view == "contact" &&
      this.$route.params.id != "all"
    ) {
      this.workingBusiness = await api.getObject("business/get", {
        businessId: this.$route.params.id,
      });
      this.$set(this.qTransactions, "businessId", this.$route.params.id);
      // this.qTransactions.businessId = this.workingBusiness.businessId;
    }
    if (this.$route.params.tags && this.$route.params.tags != "") {
      this.qTransactions.businessId = null;
      this.qTransactions.exacttag = this.$route.params.tags;
    }
    this.loaded = true;
    const val = this.$route.params.transid;
    // _log_("GO SUMS 6",this.$route);
    // this.refreshSums();
    if (val) {
      _log_("reload trans 1..", val);
      // if (val == "newpayment" || val == "newdept") {
      //   this.Transdraft = await api.getObject("transdrafts/get", {
      //     type: val == "newdept" ? "dept" : "payment",
      //     businessId: this.workingBusiness.businessId
      //   });
      //   this.listedTransactions.push(this.Transdraft);
      // } else {
      //   _log_("in..", val);
      //   var tr = this.findInArray(this.listedTransactions, { id: val });
      //   if (tr) this.Transdraft = tr;
      //   else
      //     this.Transdraft = await api.getObject("transdrafts/get", {
      //       id: val
      //     });
      // }
      this.$nextTick(() => {
        this.showDialog = true;
      });
    }
    // c
  },
  watch: {
    // "$route.params.tags"(val, oldval) {
    //   this.qTransactions.exacttag = this.$route.params.tags;
    // },

    "$route.params.id": {
      immediate: true,
      async handler(val) {
        if (this.$route.name != "transview" || !this.$route.params.view) return;
        if (val == "new") this.businessDetailsView = true;
        _log_("route.params.id rs///", val);
        if (this.$route.params.view == "contact") {
          this.$set(this.qTransactions, "businessId", val);
          this.$set(this.qTransactions, "place", null);
          this.$set(this.qTransactions, "exacttag", null);
          if (val == "new") {
            // this.$set(this.qTransactions, "businessId", null);
            this.listedTransactions = [];
            this.workingBusiness = {};
            this.workingBusiness = await api.getObject("business/get", {
              isbusiness: this.isbusiness,
              isprovider: this.issapplier,
            });
            this.activeTab = "details";
            return;
            //  @click="transactions=[];businessDialog=true; pipeActions(['=>business/get>=wBusiness'],{isbusiness:1})"
          } else if (val == "all") {
            this.workingBusiness = {};
            this.$set(this.qTransactions, "businessId", null);
            // this.qTransactions.businessId = null;
            return;
          }
          this.workingBusiness = await api.getObject("business/get", {
            businessId: val,
          });
          _log_("GO SUMS 5", this.$route);
          this.refreshSums();
          // this.qTransactions.businessId = this.workingBusiness.businessId;
        } else if (this.$route.params.view == "tags") {
          //  this.$set(this.qTransactions, "place", null);
          this.$set(this.qTransactions, "place", null);
          this.$set(this.qTransactions, "businessId", null);
          if (val && val != "") {
            if (val == "all") val = null;
            this.qTransactions.businessId = null;
            this.qTransactions.exacttag = null;
            this.$set(this.qTransactions, "exacttag", val);
            this.workingBusiness = {};

            // this.qTransactions.place = val;
            return;
          }
          _log_("GO SUMS 4", this.$route);
          this.refreshSums();
        } else if (this.$route.params.view == "places") {
          //  this.$set(this.qTransactions, "place", null);
          this.$set(this.qTransactions, "exacttag", null);
          this.$set(this.qTransactions, "businessId", null);
          if (val && val != "") {
            if (val == "all") val = null;
            this.qTransactions.businessId = null;
            this.qTransactions.exacttag = null;
            this.workingBusiness = {};
            this.$set(this.qTransactions, "place", val);
            // _log_("GO SUMS 3", this.$route);
            this.refreshSums(); // this.qTransactions.place = val;
            return;
          }
        } else {
          if (val && val != "") {
            if (val == "all") val = null;
            this.qTransactions.businessId = null;
            this.workingBusiness = {};
            this.$set(this.qTransactions, "place", null);
            this.$set(this.qTransactions, "exacttag", val);
            this.$set(this.qTransactions, "businessId", null);
            // _log_("GO SUMS 2", this.$route);
            this.refreshSums();
            // this.qTransactions.exacttag = val;
            return;
          }
        }
      },
    },
    ctx(v, vo) {
      _log_("go.transctx.", v);
      if (v && v != vo) this.qTransactions.transctx = this.ctx;
    },
    // async "$route.params.tags"(val) {
    //   if (val && val != "") {
    //     this.workingBusiness = {};
    //     this.qTransactions.exacttag = val;
    //     return;
    //   }
    // },
    async "$route.params.transid"(val) {
      if (!val) {
        this.showDialog = false;
        return;
      }
      const vm = this;
      this.$nextTick(() => {
        if (vm.$route.params.transid) this.showDialog = true;
      });

      if (this.workingBusiness.businessId)
        this.qTransactions.businessId = this.workingBusiness.businessId;
    },

    qTransactions: {
      handler: async function (val, oldVal) {
        if (this.$route.name != "transview" || !this.$route.params.view) return;
        // _log_("GO SUMS 1", this.$route);
        // this.sums = {};
        this.refreshSums();
      },
      deep: true,
    },
  },
  computed: {
    showTransactions() {
      const businessSelected =
        this.$route.params.id && this.$route.params.id != "all";
      if (!businessSelected) return true;
      return !this.businessDetailsView;
    },
    displayScope() {
      const hasScope = this.$route.params.id && this.$route.params.id != "all";
      if (!hasScope) return null;
      if (this.$route.params.view == "contact")
        return this.workingBusiness.alias
          ? this.workingBusiness.alias
          : (this.workingBusiness.name ? this.workingBusiness.name : "") +
              " " +
              (this.workingBusiness.afm ? this.workingBusiness.afm : "");
      return this.$route.params.id;
    },
    colDefinitions() {
      const vm = this,
        somethingSelected =
          this.$route.params.id && this.$route.params.id != "all";
      var cols = [];
      if (!this.qTransactions.focus)
        cols.push({
          prop: "type",
          width: "50",
          label: "",
          formatter(val, colDefs, row) {
            if (row.cost == 0) return '<i class="material-icons">comment</i>';
            if (val == "dept") {
              const extra = row.refnum
                ? 'style="color:#35180f" title="Η συνδιαλλαγη βρισκεται σε παραστατικο:' +
                  (row.refnum != 0 ? row.refnum : "μη εκδομένο") +
                  '"'
                : "";
              return (
                '<i aria-hidden="true" class="icon material-icons" ' +
                extra +
                ">shopping_cart</i>"
              );
            }
            if (val == "payment")
              return '<i aria-hidden="true" class="icon material-icons">euro_symbol</i>';
            return "-";
          },
        });
      if (this.qTransactions.focus != "notes")
        cols.push({
          prop: "paymenttype",
          width: "50",
          label: "",
          formatter(val, colDefs, row) {
            if (row.cost < 0)
              return '<i class="material-icons">settings_backup_restore</i>';

            // if (row.type == "dept") return;
            // if (!val) val = "cash";
            switch (val) {
              case "bank":
                return '<i aria-hidden="true" class="icon material-icons" >account_balance</i>';
                break;
              case "cash":
                return '<i aria-hidden="true" class="icon material-icons" >pan_tool</i>';
                break;

              case "visa":
                return '<i aria-hidden="true" class="icon material-icons" >credit_card</i>';
                break;
              case "credit-card":
                return '<i aria-hidden="true" class="icon material-icons" >credit_card</i>';
                break;
              case "stock":
                return '<i class="material-icons" >settings_backup_restore</i>';
                break;
              default:
                return "-";
                break;
            }

            return "-";
          },
        });
      cols.push({
        prop: "time",
        minWidth: 110,
        label: "Ημερ/νια",
        formatter(val, colDefs, row) {
          if (!val && !row.exectime) return "-";
          var msg = val
            ? '<span title="μερομηνια καταγραφής">' +
              vm.dateFromUnxTime(val) +
              "</span>"
            : "-";
          if (row.exectime && row.exectime - vm.unxnow() > 24 * 3600)
            msg +=
              '<span style="color:red" title="ημερομηνια μετα την οποια βρισκεται σε ισχυή η συνδιαλλαγη"><i class="material-icons">trending_up</i>' +
              vm.dateFromUnxTime(row.exectime) +
              "</span>";

          return msg;
        },
      });
      if (this.qTransactions.focus != "notes")
        cols.push({
          prop: "cost",
          minWidth: 110,
          label: "Ποσο",
          formatter(val, colDefs, row) {
            if (val) return vm.$theMoney(val) + "&euro;";
            return "-";
          },
        });
      if (this.qTransactions.focus != "notes")
        if (vm.transactionsState != "payments")
          cols.push({
            prop: "balanse",
            minWidth: 110,

            label: "Υπόλοιπο",
            formatter(val, colDefs, row) {
              // _log_(">>>", row.deptamound, val, row.deptamound - val);
              if (row.deptamound) {
                return (
                  '<button type="button" class="el-button el-button--success el-button--small">' +
                  vm.$theMoney(row.deptamound - val) +
                  "&euro;</button>"
                );
              }
              return "-";
            },
          });
      if (this.qTransactions.focus == "notes")
        cols.push({
          prop: "workload",
          width: 100,
          label: "Ε.Ω.",
        });

      if (!somethingSelected || this.$route.params.view != "contact")
        cols.push({
          prop: "name-afm",
          minWidth: 140,
          label: "Επαφη",
          alterClickable: true,
          link(val, colDefs, row, vm) {
            return (
              "/dashboard.html#/transactions/" +
              vm.$route.params.direction +
              "/contact/" +
              row["businessId"]
            );
          },
          // formatter(val) {
          //   if (val) return '<div class="clicable">' + val + "</div>";
          //   return "-";
          // }
        });
      if (!somethingSelected || this.$route.params.view != "tags")
        cols.push({
          prop: "tags",
          minWidth: 120,
          label: "Κατ/ριες",
          alterClickable: true,
          link(val, colDefs, row, vm) {
            return (
              "/dashboard.html#/transactions/" +
              vm.$route.params.direction +
              "/tags/" +
              (row["tags"] ? row["tags"] : "unset")
            );
          },
          formatter(val) {
            if (val)
              return val.replace(
                /,/g,
                '<i class="material-icons" style="font-size:10px">fiber_manual_record</i>'
              );
            return "-";
          },
        });
      if (!somethingSelected || this.$route.params.view != "places")
        cols.push({
          alterClickable: true,
          link(val, colDefs, row, vm) {
            return (
              "/dashboard.html#/transactions/" +
              vm.$route.params.direction +
              "/tags/" +
              (row["place"] ? row["place"] : "unset")
            );
          },
          prop: "place",
          clickable: true,
          minWidth: 110,
          label: "Εδρα",
        });
      cols.push({
        prop: "title",
        minWidth: this.qTransactions.focus != "notes" ? 110 : 240,
        label: "Τιτλος",
      });

      return cols;
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}
.title {
  color: aliceblue;
  text-align: center;
}
.has-more {
  color: red;
  font-weight: 700;
}

main.el-main {
  padding: 4px;
}
.out-header {
  background-color: #7e331d;
  box-shadow: 0px 2px 3px #063b44;
  border-bottom-right-radius: 4px;
}
.in-header {
  background-color: #017369;
  box-shadow: 0px 2px 3px #063b44;
  border-bottom-right-radius: 4px;
}
.el-header {
  padding: 0 4px;
}
.sum_dropdown_btn button:first-of-type {
  width: 80%;
}
.sum_dropdown_btn button:last-of-type {
  width: 20%;
}
</style>
